<script lang="ts">
  import { getContext, type Snippet } from 'svelte'

  type Props = {
    children: Snippet
    class?: string
    disabled?: boolean
  }

  const { children, class: className, disabled }: Props = $props()

  const dropdownContext = getContext<DropdownContext>('dropdownContext')
</script>

<button
  bind:this={dropdownContext.triggerElement}
  class={className}
  {disabled}
  onclick={() => (dropdownContext.isOpen = !dropdownContext.isOpen)}
>
  {@render children()}
</button>

<style lang="scss">
  button {
    background: none;
    border: none;
    color: var(--foreground);
    cursor: pointer;
    margin: 0;
    padding: 0;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
</style>
